import React from "react";

export default function NotFound() {
  return (
    <div className="not-found p-4 d-flex justify-content-center align-items-center">
      <h1 className="not-found__title">404!</h1>
    </div>
  );
}
